<span class="player-name"> {{ homePlayer() }}</span>
@for (stat of stats(); track stat.currentStat) {
    <div class="player-data">
        <div class="background-bar">
            <div class="progress" [style.width]="stat.progressBarWidth" [ngClass]="stat.betStateClassName">
                <span class="slider-handle"
                    ><span class="current-stats">{{ stat.currentStat }}</span></span
                >
            </div>
        </div>
        @if (stat.showTargetStat) {
            <span class="progress-bar-target-stat">{{ targetStatValue() }}</span>
        }
    </div>
}
<span class="player-name">{{ awayPlayer() }}</span>
